import { Image, Pressable, StyleSheet, useWindowDimensions, View } from "react-native";
import React, { useEffect, useState, useRef } from "react";
import {
  uploadImageManager,
  UploadImageManagerCallback,
} from "../../../utils/uploadImage";
import { white } from "../../../assets/style/colors";
import FastImage, {
  OnLoadEvent,
  OnProgressEvent,
} from "react-native-fast-image";
import { ContentRenderProps } from "../ContentRender";
import { LoadState, PicOrVideoRenderState } from "./ImageContentRender";
import { getImageShowSize } from "../../../utils/CommonUtils";
import * as ImSdk from "../../../../imsdk/api";
import { AnimatedCircularProgress } from "react-native-circular-progress";
import { fixRemoteUrl } from "../../../../imsdk/api";
import MediaPlaceholder from "../../../components/MediaPlaceholder";

export const VideoRender = (props: ContentRenderProps) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const hasLoadedMetaRef = useRef(false);
  const { width: screenWidth } = useWindowDimensions();
  const metaW = Number(props.item.meta.width ?? "0");
  const metaH = Number(props.item.meta.height ?? "0");
  const showSize = getImageShowSize(metaW, metaH, screenWidth);
  const content = fixRemoteUrl(props.item.content);
  const [state, setState] = useState<PicOrVideoRenderState>({
    size: [showSize.width, showSize.height],
    progress: 0,
    loadProgress: 0,
    loadState: LoadState.LoadStart,
    loaclLoadError: false,
    opacity: 1,
    uploading: props.item.upload_statue === "0",
  });

  const videoUrl = content;


  console.log("=======>", videoUrl,);

  const [retryCount, setRetryCount] = useState(0);

  /** 获取视频尺寸（metadata） */
  const handleLoadedMetadata = () => {
    if (!videoRef.current || hasLoadedMetaRef.current) return;
	if (videoRef.current) {
		// 👇 强制解码第一帧
		videoRef.current.currentTime = 0.01;
	  }
    const width = videoRef.current.videoWidth;
    const height = videoRef.current.videoHeight;

    if (!width || !height) return;

    hasLoadedMetaRef.current = true;

    const showSize = getImageShowSize(width, height, 375);

    setState((prev) => ({
      ...prev,
      size: [showSize.width, showSize.height],
    }));

    props.item.meta.width = String(width);
    props.item.meta.height = String(height);
    ImSdk.getInstance().updateMsgMeta(props.item.mid, props.item.meta);
  };

  /** 上传进度监听 */
  useEffect(() => {
    const key = `${props.item.sender}-${props.item.cid}-${props.item.upload_path}`;
    const isUpload = props.item.upload_statue === "0";

    setState((prev) => ({ ...prev, uploading: isUpload }));

    if (!isUpload) return;

    const listener: UploadImageManagerCallback = {
      onUploadProgress(progress) {
        setState((prev) => ({
          ...prev,
          progress,
        }));
      },
      onSuccess() {
        setState((prev) => ({
          ...prev,
          progress: 100,
          opacity: 0,
          uploading: false,
        }));
      },
      onFail() {
        setState((prev) => ({
          ...prev,
          progress: 100,
          opacity: 0,
          uploading: false,
        }));
      },
    };

    uploadImageManager.addListener(key, listener);
    return () => uploadImageManager.removeListener(key);
  }, [props.item.upload_statue]);

  const handleClick = () => {
    props.onClick?.();
  };

  const handleRetry = () => {
    if (state.loadState !== LoadState.LoadEnd && state.loadState !== LoadState.LoadError) {
      return; // 如果正在加载或者没有错误，不执行重试
    }

    setRetryCount(prev => {
      if (prev >= 3) {
        return 0; // 重置重试次数
      }
      return prev + 1;
    });
  }

  const onLoadStart = () => {
    setState((prevState) => {
      if (prevState.loadState !== LoadState.LoadStart) {
        return { ...prevState, loadState: LoadState.LoadStart };
      }
      return prevState;
    });
  };

  const handleLoadEnd = () => {
    // 使用 ref 防止重复调用
    setState((prevState) => {
      // 只有状态不同时才更新，避免不必要的重新渲染
      if (prevState.loadState !== LoadState.LoadEnd) {
        return { ...prevState, loadState: LoadState.LoadEnd };
      }
      return prevState;
    });

  };

  const handleLoadError = (e: any) => {
    //无论成功或失败都会onLoadEnd,
    setState((prevState) => {
      if (prevState.loadState !== LoadState.LoadError) {
        return { ...prevState, loadState: LoadState.LoadError };
      }
      return prevState;
    });
  };

  return (
    <Pressable
      onLongPress={props.onLongPress}
      onPress={handleClick}
      disabled={props.talkSelectStatus === true || props.disabled === true}
      style={[
        styles.container,
        {
          width: state.size[0],
          height: state.size[1],
        },
      ]}
    >
      {/* Web 原生 video */}
      <video
        key={`${content}_${retryCount}`} // 通过改变key来强制刷新图片
        ref={videoRef}
        src={videoUrl}
        muted
        preload="metadata"
        playsInline
        onLoadedMetadata={handleLoadedMetadata}
        onLoadStart={onLoadStart}
        onLoad={handleLoadEnd}
        onError={handleLoadError}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 5,
          backgroundColor: "#000",
        }}
      />

      {/* 播放按钮 */}
      <Image
        source={require("../../../assets/image/icon_play.png")}
        style={styles.playIcon}
      />

      {/* 上传进度 */}
      {state.uploading && props.item.send_statue !== "1" && (
        <View style={[styles.overlay, { opacity: state.opacity }]}>
          <AnimatedCircularProgress
            size={80}
            width={8}
            fill={state.progress}
            tintColor={white}
          />
        </View>
      )}

      {/* 加载失败 */}
      {state.loadState === LoadState.LoadError && (
        <View style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: showSize.width,
          height: showSize.height,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <MediaPlaceholder
            type={'video'}
            status={'error'}
            width={showSize.width}
            height={showSize.height}
            marginVertical={0}
            showReroad={false}
            onPress={handleRetry} />
        </View>
      )}
    </Pressable>
  );
};

export const VideoContentRender = React.memo(
  VideoRender,
  (prevProps, nextProps) => {
    // 使用更精确的比较，避免对象引用比较导致的无限循环
    return (
      prevProps.item.mid === nextProps.item.mid &&
      prevProps.item.content === nextProps.item.content &&
      prevProps.item.upload_path === nextProps.item.upload_path &&
      prevProps.item.upload_statue === nextProps.item.upload_statue &&
      prevProps.item.sender === nextProps.item.sender &&
      prevProps.item.cid === nextProps.item.cid &&
      prevProps.talkSelectStatus === nextProps.talkSelectStatus &&
      prevProps.disabled === nextProps.disabled
    );
  }
);

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000",
    borderRadius: 5,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.6)", // 半透明黑色背景
    justifyContent: "center",
    alignItems: "center",
  },
  progressText: {
    color: "#fff",
    marginTop: 8,
    fontSize: 14,
  },
  playIcon: {
    position: "absolute",
    borderRadius: 50,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    width: 50,
    height: 50,
    zIndex: 99
  },
});
